<h1 mat-dialog-title>{{title}}
  <sfc-icon name="rds-icon-times" size="xs" class="clickable" (click)="close()">
  </sfc-icon>
</h1>
<div mat-dialog-content>
  <div *ngIf='hasData ; else errorTextField'>
    <ng-container #table></ng-container>
    <div class="sub-panel">
      <div class="details-panel">
        <span class="header-text not-expandable">Tarieven provisie op jaarbasis:</span>
      </div>
      <div class="details-name-value-pairs">
        <div class="details-name-value-pair">
          <label class="details-name">Minimaal tarief provisie</label>
              <div class="details-value" [ngClass]="{'red': minimumRate < 0}">
                {{getAmountInPercentage(minimumRate)}}
              </div>
        </div>
        <div class="details-name-value-pair">
          <label class="details-name">Maximaal tarief provisie</label>
          <div class="details-value" [ngClass]="{'red': maximumRate < 0}">
            {{getAmountInPercentage(maximumRate)}}
          </div>
        </div>
        <div class="details-name-value-pair">
          <label class="details-name">Vast tarief provisie</label>
          <div class="details-value" [ngClass]="{'red': flatRate < 0}">
            {{getAmountInPercentage(flatRate)}}
          </div>
        </div>

      </div>
    </div>
  </div>
</div>


<ng-template #errorTextField>
  <div class="error-text">
    {{errorText}}
  </div>
</ng-template>
